import { t } from "i18next";
import { Button, Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const Stepper = ({ step }: any) => {
  const tabs = ["data_history", "workflows", "content_workflow"];
  const handleStepSteper = (status: string) => {
    switch (status) {
      case "workflows":
        return `/app/client-dashboard/workflow-list`;
      case "data_history":
        return `/app/client-dashboard/data-history`;
      case "content_workflow":
        return `/app/client-dashboard/content-workflow-list`;
      default:
        return `/app/client-dashboard/workflow-list`;
    }
  };
  return (
    <Row>
      <Col md={12}>
        <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3">
          {tabs?.map((stepName: string) => {
            return (
              <li className="nav-item" key={stepName}>
                <Link
                  className={`nav-link ${step === stepName ? "active" : ""}`}
                  to={handleStepSteper(stepName)}
                >
                  {t(`client_dashboard.${stepName}`)}
                </Link>
              </li>
            );
          })}
        </ul>
      </Col>
    </Row>
  );
};
